import borderBox1 from './border-box-1/index'
import borderBox2 from './border-box-2/index'
import borderBox3 from './border-box-3/index'
import borderBox4 from './border-box-4/index'
import borderBox5 from './border-box-5/index'
import borderBox6 from './border-box-6/index'
import boxModal from '../modal/index.js'

export default function (Vue) {
  Vue.use(borderBox1)
  Vue.use(borderBox2)
  Vue.use(borderBox3)
  Vue.use(borderBox4)
  Vue.use(borderBox5)
  Vue.use(borderBox6)
  Vue.use(boxModal)
}



// WEBPACK FOOTER //
// ./src/components/border/index.js